<app-splash-screen></app-splash-screen>
<div
  class="main-div"
  [ngClass]="{
    'mobile-screen': deviceInfoModel.isMobile,
    'tablet-screen': deviceInfoModel.isTablet,
    'desktop-screen': deviceInfoModel.isDesktop
  }"
>
  <router-outlet></router-outlet>
</div>
<p-toast [baseZIndex]="5000" [position]="deviceInfoModel.isMobile ? 'bottom-center' : 'bottom-right'" [preventOpenDuplicates]="true"></p-toast>

<p-confirmDialog [style]="{ width: '50vw' }" [closable]="false" key="version-update"></p-confirmDialog>
